import { message, PageHeader, Spin, Upload, Row, Col, Alert } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from 'axios'
import {
  Form,
  FormItem,
  TableItem,
  ButtonItem,
} from "../../../../Components/Items";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from 'xlsx'
import moment from 'moment'
import {
  EJEMPLO_PLANTILLA,
  construirLibroPlantilla,
  descargarLibroPlantilla,
  hojaTabla,
  textoCodigosRepetidos,
} from "./plantillaEmpleados";
import { agruparAvisosCatalogo } from "../ImportarEmpleadosExterno/mapeoExterno";

class ImportarEmpleados extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    archivosExcel: [],
    data: [],
    archivoError: null,
    // Valores de catálogo que venían escritos y no existen en esta empresa (agruparAvisosCatalogo)
    avisosCatalogo: [],
    // Catálogos para resolución de IDs
    tiposContrato: [],
    formasDePago: [],
    turnos: [],
    tiposPeriodo: [],
    tiposPrestacion: [],
    bancos: [],
    registrosPatronales: [],
    regimenFiscal: [],
    tiposRegimen: [],
    tiposJornada: [],
    estados: [],
  }

  componentDidMount() {
    this.setState({ loading: true })
    axios
      .post(
        "empleados/datosParaImportarEmpleados",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            tiposContrato:      res.data.tiposContrato      || [],
            formasDePago:       res.data.formasDePago       || [],
            turnos:             res.data.turnos             || [],
            tiposPeriodo:       res.data.tiposPeriodo       || [],
            tiposPrestacion:    res.data.tiposPrestacion    || [],
            bancos:             res.data.bancos             || [],
            registrosPatronales: res.data.registrosPatronales || [],
            regimenFiscal:      res.data.regimenFiscal      || [],
            tiposRegimen:       res.data.tiposRegimen       || [],
            tiposJornada:       res.data.tiposJornada       || [],
            estados:            res.data.estados            || [],
          });
        }
        this.setState({ loading: false });
      });
  }

  atras() {
    this.props.history.goBack();
  }

  onFinishFailed() {
    message.error("Revisa que los datos sean correctos");
  }

  onFinish() {
    if (!this.state.data.length) {
      message.error("No hay datos para importar");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "empleados/importarEmpleados",
        { empresaId: this.props.empresaId, data: this.state.data },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se importaron " + res.data.numero + " empleados");
          if (res.data.repetidos) {
            message.warning("No se importaron " + res.data.repetidos + " empleados ya que estaban repetidos");
          }
          if (res.data.fallidos) {
            message.warning("No se importaron " + res.data.fallidos + " empleados por datos inválidos");
          }
          const avisoCodigos = textoCodigosRepetidos(res.data.codigosRepetidos);
          if (avisoCodigos) message.warning(avisoCodigos, 10);
          if (res.data.lideresNoEncontrados) {
            message.warning("No se encontró el líder de " + res.data.lideresNoEncontrados + " empleado(s); asígnalo manualmente");
          }
          this.atras();
        } else if (res.data.success === 1) {
          message.error("No se pueden importar los empleados");
        } else {
          message.error("Hubo un error y los empleados no se importaron");
        }
      });
  }

  async onChangeArchivo(e) {
    this.setState({ loading: true })
    if (e.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.setState({ archivosExcel: [{ ...e.file, name: e.file.name, status: 'uploading', response: 'Cargando' }] });
      this.cargarArchivoExcel(e.file)
    } else {
      message.error('El archivo debe ser un archivo de excel')
      this.setState({ loading: false })
    }
  }

  descargarArchivoErrores() {
    let wbout = XLSX.write(this.state.archivoError, { bookType: 'xlsx', type: 'binary' });
    const s2ab = (s) => {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" })
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'errores_empleados.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  cargarArchivoExcel(file) {
    let hojas = [];
    let reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onloadend = (e) => {
      let data = new Uint8Array(e.target.result)
      let workbook = XLSX.read(data, { type: 'array', cellDates: true })
      workbook.SheetNames.forEach((sheetName) => {
        let rows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName], { raw: false, dateNF: 'YYYY-MM-DD' })
        hojas.push({ data: rows, sheetName })
      })
      let hoja1 = hojas[0].data
      this.archivoVerificar(hoja1).then((dataReturn) => {
        if (dataReturn.errores === 0) {
          this.setState({
            archivosExcel: [{ ...file, name: file.name, status: 'success' }],
            archivoError: null,
            data: dataReturn.objeto,
            avisosCatalogo: dataReturn.avisosCatalogo,
          });
        } else {
          this.setState({
            archivosExcel: [{ ...file, name: file.name, status: 'success', response: 'Con errores' }],
            archivoError: dataReturn.archivoErrores,
            data: dataReturn.objeto,
            avisosCatalogo: dataReturn.avisosCatalogo,
          });
          message.error('Se han detectado ' + dataReturn.errores + ' errores')
          message.info('Solo se importarán los registros correctos: ' + (hoja1.length - dataReturn.filaErrores))
        }
        this.setState({ loading: false })
      })
    }
  }

  parsearFecha(valor) {
    if (!valor) return undefined;
    const str = String(valor).trim();
    const formatos = ['YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY', 'DD-MM-YYYY', 'YYYY/MM/DD', 'D/M/YYYY', 'DD/MM/YY'];
    for (const fmt of formatos) {
      const m = moment(str, fmt, true);
      if (m.isValid()) return m.format('YYYY-MM-DD');
    }
    return undefined;
  }

  mapearSexo(valor) {
    if (!valor) return undefined;
    const v = String(valor).trim().toUpperCase();
    if (['H', 'M', 'MASCULINO', 'HOMBRE', 'MALE'].includes(v)) return 'Hombre';
    if (['F', 'FEMENINO', 'MUJER', 'FEMALE'].includes(v)) return 'Mujer';
    if (v === 'NO APLICA') return 'No Aplica';
    return undefined;
  }

  mapearEstadoCivil(valor) {
    if (!valor) return undefined;
    const v = String(valor).trim().toUpperCase();
    const mapa = {
      'S': 1, 'SOLTERO': 1, 'SOLTERA': 1,
      'C': 2, 'CASADO': 2, 'CASADA': 2,
      'CO': 3, 'CONCUBINATO': 3,
      'U': 4, 'UNION CIVIL': 4, 'UNIÓN CIVIL': 4,
      'V': 5, 'VIUDO': 5, 'VIUDA': 5,
      'D': 6, 'DIVORCIADO': 6, 'DIVORCIADA': 6,
    };
    return mapa[v] ?? undefined;
  }

  mapearBasePago(valor) {
    if (!valor) return undefined;
    const v = String(valor).trim().toUpperCase();
    const mapa = {
      'SUELDO': 1, '1': 1,
      'COMISION': 2, 'COMISIÓN': 2, '2': 2,
      'DESTAJO': 3, '3': 3,
      'SUELDO-COMISION': 4, 'SUELDO-COMISIÓN': 4, '4': 4,
      'SUELDO-DESTAJO': 5, '5': 5,
    };
    return mapa[v] ?? undefined;
  }

  resolverCatalogo(valor, catalogo, campoNombre) {
    if (!valor) return {};
    const v = String(valor).trim().toLowerCase();
    // c_FormaPago y c_RegimenFiscal se guardan como Number: "04" tiene que empatar con 4.
    const sinCeros = (s) => s.replace(/^0+(?=\d)/, '');
    const encontrado = catalogo.find((item) => {
      const nombre = String(item.nombre || item.Descripcion || item.descripcion || '').trim().toLowerCase();
      const clave  = String(item.c_TipoContrato || item.c_FormaPago || item.c_TipoJornada ||
                    item.c_RegimenFiscal || item.c_TipoRegimen || item.abreviatura || '').trim().toLowerCase();
      return nombre === v || (clave !== '' && (clave === v || sinCeros(clave) === sinCeros(v)));
    });
    if (encontrado) return { [`${campoNombre}Id`]: encontrado._id, [campoNombre]: valor };
    return { [campoNombre]: valor };
  }

  resolverRegistroPatronal(valor) {
    if (!valor) return {};
    const v = String(valor).trim();
    const encontrado = this.state.registrosPatronales.find(
      (r) => r.registroPatronalIMSS.trim() === v
    );
    if (encontrado) return { registroPatronalId: encontrado._id, registroPatronalIMSS: v };
    return { registroPatronalIMSS: v };
  }

  resolverTurno(valor) {
    if (!valor) return {};
    const v = String(valor).trim().toLowerCase();
    const encontrado = this.state.turnos.find((t) => t.nombre.trim().toLowerCase() === v);
    if (encontrado) return { turnoId: encontrado._id, turno: valor };
    return { turno: valor };
  }

  resolverBanco(valor) {
    if (!valor) return {};
    const v = String(valor).trim().toLowerCase();
    const encontrado = this.state.bancos.find((b) => b.nombre.trim().toLowerCase() === v);
    if (encontrado) return { bancoId: encontrado._id, banco: valor };
    return { banco: valor };
  }

  resolverEstado(valor) {
    if (!valor) return {};
    const v = String(valor).trim().toLowerCase();
    const encontrado = this.state.estados.find(
      (e) => e.nombre.trim().toLowerCase() === v || (e.abreviatura || '').trim().toLowerCase() === v
    );
    if (encontrado) return { estadoId: encontrado._id, estado: valor };
    return { estado: valor };
  }

  async archivoVerificar(data) {
    let errores = 0
    let filaErrores = 0
    const archivoEditar = XLSX.utils.book_new()
    const arrayErrores = []
    let objeto = []
    // { catalogo, valor } de lo que se va a guardar vacío porque el catálogo no lo tiene. Es lo que
    // pasa al traer empleados de otra empresa sin haber dado de alta antes su registro patronal,
    // sus periodos o sus turnos.
    const avisosCatalogo = []

    await Promise.all(data.map(async (fila) => {
      let mensajeErrores = null
      let erroresFila = 0
      let numFila = fila['__rowNum__'] !== undefined ? fila['__rowNum__'] + 1 : 2
      let emp = {}
      const sinResolverFila = []

      const leer = (col) => fila[col] ? String(fila[col]).trim() : undefined

      // ── Datos básicos ───────────────────────────────────────────────
      const numero           = leer('Numero')
      const nombre           = leer('Nombre')
      const apellidoPaterno  = leer('Apellido Paterno')
      const apellidoMaterno  = leer('Apellido Materno')
      const rfc              = leer('RFC')
      const curp             = leer('CURP')
      const nss              = leer('NSS')
      const correo           = leer('Correo')
      const telefono         = leer('Telefono')
      const nombrePadre      = leer('Nombre Padre')
      const nombreMadre      = leer('Nombre Madre')
      const umf              = leer('UMF')
      const expediente       = leer('Expediente')
      const clabe            = leer('CLABE')
      const cuentaBancaria   = leer('Cuenta Bancaria')

      // ── Fechas ──────────────────────────────────────────────────────
      const fechaAltaRaw        = leer('Fecha Alta')
      const fechaReingresoRaw   = leer('Fecha Reingreso')
      const fechaNacRaw         = leer('Fecha Nacimiento')
      const fechaSalDiarioRaw   = leer('Fecha Salario Diario')
      const fechaSalIntegradoRaw = leer('Fecha Salario Integrado')

      // ── Números ─────────────────────────────────────────────────────
      const salarioDiarioRaw  = leer('Salario Diario')
      const sbcRaw            = leer('SBC')
      const salVariableRaw    = leer('Salario Variable')
      const salPromedioRaw    = leer('Salario Promedio')
      const sbcVariableRaw    = leer('SBC Variable')
      const fonacotRaw        = leer('FONACOT')
      const afore             = leer('AFORE')

      // ── Enumerados simples ──────────────────────────────────────────
      const sexoRaw           = leer('Sexo')
      const estadoCivilRaw    = leer('Estado Civil')
      const basePagoRaw       = leer('Base Pago')
      const baseCotizacionRaw = leer('Base Cotizacion')
      const sindicalizadoRaw  = leer('Sindicalizado')
      const externoRaw        = leer('Externo')
      const calculoPTURaw     = leer('Calculo PTU')
      const calculoAguinaldoRaw = leer('Calculo Aguinaldo')
      const extranjeroSinCurpRaw = leer('Extranjero Sin CURP')

      // ── Catálogos que el back resuelve por ID ────────────────────────
      const tipoContratoVal   = leer('Tipo Contrato')
      const tipoPeriodoVal    = leer('Tipo Periodo')
      const tipoJornadaVal    = leer('Tipo Jornada')
      const formaPagoVal      = leer('Forma Pago')
      const bancoVal          = leer('Banco')
      const sucursal          = leer('Sucursal')
      const tipoPrestacionVal = leer('Tipo Prestacion')
      const turnoVal          = leer('Turno')
      const regPatronalVal    = leer('Registro Patronal')
      const regimenFiscalVal  = leer('Regimen Fiscal')
      const tipoRegimenVal    = leer('Tipo Regimen')

      // ── Domicilio ───────────────────────────────────────────────────
      const calle            = leer('Calle')
      const numeroExt        = leer('Numero Ext')
      const numeroInt        = leer('Numero Int')
      const colonia          = leer('Colonia')
      const municipio        = leer('Municipio')
      const estadoDom        = leer('Estado')
      const pais             = leer('Pais')
      const cp               = leer('CP')
      const estadoNacVal     = leer('Estado Nacimiento')
      const ciudadNac        = leer('Ciudad Nacimiento')

      // ──────────────────────────────────────────────────────────────
      // Validaciones obligatorias
      // ──────────────────────────────────────────────────────────────
      const queEste = (valor, campo) => {
        if (!valor) {
          errores++; erroresFila++;
          mensajeErrores = mensajeErrores ? mensajeErrores + `, ${campo} está vacío` : `${campo} está vacío`
        }
      }
      const checarNumero = (valor, campo) => {
        if (!valor) return undefined;
        const limpio = String(valor).replace(/[$\s,]/g, '')
        // El formato Contabilidad de Excel pinta el cero como "$ -".
        if (limpio === '-') return 0
        const n = Number(limpio)
        if (isNaN(n)) {
          errores++; erroresFila++;
          mensajeErrores = mensajeErrores ? mensajeErrores + `, ${campo} no es número` : `${campo} no es número`
          return undefined
        }
        return n
      }

      queEste(nombre, 'Nombre')
      queEste(apellidoPaterno, 'Apellido Paterno')
      queEste(rfc, 'RFC')
      queEste(fechaAltaRaw, 'Fecha Alta')

      // RFC
      if (rfc) {
        const rfcL = rfc.toUpperCase()
        if (!/^[A-ZÑ&]{3,4}\d{6}[A-Z\d]{3}$/.test(rfcL)) {
          errores++; erroresFila++;
          mensajeErrores = mensajeErrores ? mensajeErrores + `, RFC formato inválido` : `RFC formato inválido`
        } else {
          emp.rfc = rfcL
        }
      }

      // Fechas
      const parsearYGuardar = (raw, campo) => {
        if (!raw) return;
        const f = this.parsearFecha(raw)
        if (!f) {
          errores++; erroresFila++;
          mensajeErrores = mensajeErrores ? mensajeErrores + `, ${campo} formato inválido` : `${campo} formato inválido`
        } else {
          emp[campo] = f
        }
      }
      parsearYGuardar(fechaAltaRaw,         'fechaAlta')
      parsearYGuardar(fechaReingresoRaw,     'fechaReingreso')
      parsearYGuardar(fechaNacRaw,           'fechaNacimiento')
      parsearYGuardar(fechaSalDiarioRaw,     'fechaSalarioDiario')
      parsearYGuardar(fechaSalIntegradoRaw,  'fechaSalarioIntegrado')

      // Números
      const salarioDiario = checarNumero(salarioDiarioRaw, 'Salario Diario')
      const sbc           = checarNumero(sbcRaw,           'SBC')
      const salVariable   = checarNumero(salVariableRaw,   'Salario Variable')
      const salPromedio   = checarNumero(salPromedioRaw,   'Salario Promedio')
      const sbcVariable   = checarNumero(sbcVariableRaw,   'SBC Variable')
      const fonacot       = checarNumero(fonacotRaw,       'FONACOT')

      if (salarioDiario !== undefined) emp.salarioDiario  = salarioDiario
      if (sbc           !== undefined) emp.sbcParteFija   = sbc
      if (salVariable   !== undefined) emp.salarioVariable = salVariable
      if (salPromedio   !== undefined) emp.salarioPromedio = salPromedio
      if (sbcVariable   !== undefined) emp.sbcParteVariable = sbcVariable
      if (fonacot       !== undefined) emp.numeroFONACOT  = fonacot
      if (afore)                        emp.afore          = afore

      // Enumerados simples
      if (sexoRaw) {
        const s = this.mapearSexo(sexoRaw)
        if (s) emp.sexo = s
      }
      if (estadoCivilRaw) {
        const ec = this.mapearEstadoCivil(estadoCivilRaw)
        if (ec !== undefined) emp.estadoCivil = ec
      }
      if (basePagoRaw) {
        const bp = this.mapearBasePago(basePagoRaw)
        if (bp !== undefined) emp.basePago = bp
      }
      if (baseCotizacionRaw) {
        const bc = this.mapearBasePago(baseCotizacionRaw)
        if (bc !== undefined) emp.baseDeCotizacion = bc
      }

      const esSi = (v) => v && ['SI', 'SÍ', 'S', 'YES', 'Y', '1', 'TRUE'].includes(String(v).trim().toUpperCase())
      if (sindicalizadoRaw !== undefined) emp.sindicalizado = esSi(sindicalizadoRaw)
      if (externoRaw       !== undefined) emp.externo       = esSi(externoRaw)
      // Sólo si la celda trae algo: vacía tiene que dejar el default (PTU y aguinaldo en true).
      if (calculoPTURaw        !== undefined) emp.calculoPTU        = !!esSi(calculoPTURaw)
      if (calculoAguinaldoRaw  !== undefined) emp.calculoAguinaldo  = !!esSi(calculoAguinaldoRaw)
      if (extranjeroSinCurpRaw !== undefined) emp.extranjeroSinCurp = !!esSi(extranjeroSinCurpRaw)

      // Catálogos — siempre se manda el string; si se encontró el ID también se manda. Lo que
      // venía escrito y no se encontró se anota para avisar que ese campo quedará vacío.
      const resolver = (columna, valor, resuelto, llaveId) => {
        if (valor && !resuelto[llaveId]) sinResolverFila.push({ catalogo: columna, valor })
        Object.assign(emp, resuelto)
      }
      resolver('Tipo Contrato',     tipoContratoVal,   this.resolverCatalogo(tipoContratoVal,   this.state.tiposContrato,    'tipoContrato'),   'tipoContratoId')
      resolver('Tipo Periodo',      tipoPeriodoVal,    this.resolverCatalogo(tipoPeriodoVal,    this.state.tiposPeriodo,     'tipoPeriodo'),    'tipoPeriodoId')
      resolver('Tipo Jornada',      tipoJornadaVal,    this.resolverCatalogo(tipoJornadaVal,    this.state.tiposJornada,     'tipoJornada'),    'tipoJornadaId')
      resolver('Forma Pago',        formaPagoVal,      this.resolverCatalogo(formaPagoVal,      this.state.formasDePago,     'formaDePago'),    'formaDePagoId')
      resolver('Tipo Prestacion',   tipoPrestacionVal, this.resolverCatalogo(tipoPrestacionVal, this.state.tiposPrestacion,  'tipoPrestacion'), 'tipoPrestacionId')
      resolver('Regimen Fiscal',    regimenFiscalVal,  this.resolverCatalogo(regimenFiscalVal,  this.state.regimenFiscal,    'regimenFiscal'),  'regimenFiscalId')
      resolver('Tipo Regimen',      tipoRegimenVal,    this.resolverCatalogo(tipoRegimenVal,    this.state.tiposRegimen,     'tipoRegimen'),    'tipoRegimenId')
      resolver('Turno',             turnoVal,          this.resolverTurno(turnoVal),                   'turnoId')
      resolver('Banco',             bancoVal,          this.resolverBanco(bancoVal),                   'bancoId')
      resolver('Registro Patronal', regPatronalVal,    this.resolverRegistroPatronal(regPatronalVal),  'registroPatronalId')

      // Estado nacimiento y domicilio
      if (estadoNacVal) {
        const r = this.resolverEstado(estadoNacVal)
        if (r.estadoId) emp.estadoNacimientoId = r.estadoId
        else sinResolverFila.push({ catalogo: 'Estado Nacimiento', valor: estadoNacVal })
        emp.estadoNacimiento = estadoNacVal
      }
      if (estadoDom) {
        const r = this.resolverEstado(estadoDom)
        if (r.estadoId) emp.estadoDomicilioId = r.estadoId
        emp.estadoDomicilio = estadoDom
      }

      // Domicilio texto libre
      if (calle)      emp.calle         = calle
      if (numeroExt)  emp.numeroCalle   = numeroExt
      if (numeroInt)  emp.numeroInterior = numeroInt
      if (colonia)    emp.colonia       = colonia
      if (municipio)  emp.municipio     = municipio
      if (pais)       emp.pais          = pais
      if (cp)         emp.cp            = cp
      if (ciudadNac)  emp.ciudadNacimientoId = ciudadNac

      // Campos libres restantes
      if (curp)          emp.curp                  = curp
      if (nss)           emp.numSeguridadSocial     = nss
      if (correo)        emp.correoElectronico      = correo
      if (telefono)      emp.telefono               = telefono
      if (nombrePadre)   emp.nombrePadre            = nombrePadre
      if (nombreMadre)   emp.nombreMadre            = nombreMadre
      if (umf)           emp.umf                    = umf
      if (expediente)    emp.expediente             = expediente
      if (clabe)         emp.clabe                  = clabe
      if (cuentaBancaria) emp.cuentaBancaria         = cuentaBancaria
      if (sucursal)      emp.sucursalPagoElectronico = sucursal

      // Departamento y puesto siempre como string — back los da de alta si no existen
      const departamento = leer('Departamento')
      const puesto       = leer('Puesto')
      if (departamento) emp.departamento = departamento
      if (puesto)       emp.puesto       = puesto

      // El back busca al líder por `codigo` entre los activos, ya con todo el lote guardado, y lo
      // compara como texto: "0012" no empataría con el 12.
      const liderDirecto = leer('Lider Directo')
      if (liderDirecto) {
        const n = Number(liderDirecto)
        emp.liderCodigo = Number.isFinite(n) ? String(n) : liderDirecto
      }

      if (erroresFila === 0) {
        objeto.push({ numeroClave: numero, nombre, apellidoPaterno, apellidoMaterno, ...emp })
        avisosCatalogo.push(...sinResolverFila)
      } else {
        arrayErrores.push({ Errores: mensajeErrores, Fila: numFila, ...fila })
        filaErrores++
      }
      return null
    }))

    const hoja = XLSX.utils.json_to_sheet(arrayErrores)
    XLSX.utils.book_append_sheet(archivoEditar, hoja, 'Hoja Errores')
    return { objeto, errores, filaErrores, archivoErrores: archivoEditar, avisosCatalogo: agruparAvisosCatalogo(avisosCatalogo) }
  }

  // La plantilla sale del mismo constructor que el "Exportar Empleados" de la lista (ver
  // plantillaEmpleados.js): una fila de ejemplo aquí, los empleados reales allá.
  descargarPlantilla() {
    const hojasExtra = []
    // Hojas de referencia para los catálogos descargados
    const agregarHojaRef = (nombre, arr, mapFn) => {
      if (!arr.length) return;
      hojasExtra.push({ nombre, hoja: hojaTabla(arr.map(mapFn)) })
    }

    agregarHojaRef('Tipos Contrato',   this.state.tiposContrato,   (v) => ({ Clave: v.c_TipoContrato, Descripcion: v.Descripcion }))
    agregarHojaRef('Tipos Periodo',    this.state.tiposPeriodo,    (v) => ({ Nombre: v.nombre }))
    agregarHojaRef('Tipos Jornada',    this.state.tiposJornada,    (v) => ({ Clave: v.c_TipoJornada, Descripcion: v.Descripcion }))
    agregarHojaRef('Formas Pago',      this.state.formasDePago,    (v) => ({ Clave: v.c_FormaPago, Descripcion: v.descripcion }))
    agregarHojaRef('Tipos Prestacion', this.state.tiposPrestacion, (v) => ({ Nombre: v.nombre }))
    agregarHojaRef('Turnos',           this.state.turnos,          (v) => ({ Nombre: v.nombre }))
    agregarHojaRef('Regimen Fiscal',   this.state.regimenFiscal,   (v) => ({ Clave: v.c_RegimenFiscal, Descripcion: v.descripcion }))
    agregarHojaRef('Tipos Regimen',    this.state.tiposRegimen,    (v) => ({ Clave: v.c_TipoRegimen, Descripcion: v.descripcion }))
    agregarHojaRef('Registros Patronales', this.state.registrosPatronales, (v) => ({ Registro: v.registroPatronalIMSS }))
    agregarHojaRef('Bancos',           this.state.bancos,          (v) => ({ Nombre: v.nombre }))
    agregarHojaRef('Estados',          this.state.estados,         (v) => ({ Nombre: v.nombre, Abreviatura: v.abreviatura }))

    descargarLibroPlantilla(construirLibroPlantilla([EJEMPLO_PLANTILLA], { hojasExtra }), 'plantillaEmpleados.xlsx')
  }

  render() {
    const columns = [
      { title: 'Num.', dataIndex: 'numeroClave', key: 'numeroClave', width: 60 },
      {
        title: 'Nombre Completo', key: 'nombreCompleto', width: 200, fixed: 'left',
        render: (_, r) => [r.nombre, r.apellidoPaterno, r.apellidoMaterno].filter(Boolean).join(' '),
      },
      { title: 'RFC',  dataIndex: 'rfc',  key: 'rfc',  width: 140 },
      { title: 'CURP', dataIndex: 'curp', key: 'curp', width: 190 },
      { title: 'NSS',  dataIndex: 'numSeguridadSocial', key: 'nss', width: 120 },
      { title: 'Fecha Alta', dataIndex: 'fechaAlta', key: 'fechaAlta', width: 110,
        render: (v) => v ? moment(v).format('DD/MM/YYYY') : '-' },
      { title: 'Fecha Nac.', dataIndex: 'fechaNacimiento', key: 'fechaNac', width: 110,
        render: (v) => v ? moment(v).format('DD/MM/YYYY') : '-' },
      { title: 'Sexo', dataIndex: 'sexo', key: 'sexo', width: 75, render: (v) => v || '-' },
      { title: 'Sal. Diario', dataIndex: 'salarioDiario', key: 'salDiario', width: 100,
        render: (v) => v !== undefined ? `$${v}` : '-' },
      { title: 'SBC', dataIndex: 'sbcParteFija', key: 'sbc', width: 90,
        render: (v) => v !== undefined ? `$${v}` : '-' },
      { title: 'Departamento', dataIndex: 'departamento', key: 'depto', width: 130, render: (v) => v || '-' },
      { title: 'Puesto', dataIndex: 'puesto', key: 'puesto', width: 130, render: (v) => v || '-' },
      { title: 'Tipo Contrato', dataIndex: 'tipoContrato', key: 'tipoContrato', width: 120, render: (v) => v || '-' },
      { title: 'Tipo Periodo', dataIndex: 'tipoPeriodo', key: 'tipoPeriodo', width: 120, render: (v) => v || '-' },
      { title: 'Forma Pago', dataIndex: 'formaDePago', key: 'formaPago', width: 110, render: (v) => v || '-' },
      { title: 'Banco', dataIndex: 'banco', key: 'banco', width: 110, render: (v) => v || '-' },
      { title: 'CLABE', dataIndex: 'clabe', key: 'clabe', width: 185, render: (v) => v || '-' },
      { title: 'Turno', dataIndex: 'turno', key: 'turno', width: 100, render: (v) => v || '-' },
      { title: 'Reg. Patronal', dataIndex: 'registroPatronalIMSS', key: 'regPatronal', width: 130, render: (v) => v || '-' },
      { title: 'Régimen Fiscal', dataIndex: 'regimenFiscal', key: 'regimenFiscal', width: 120, render: (v) => v || '-' },
      { title: 'Correo', dataIndex: 'correoElectronico', key: 'correo', width: 180, render: (v) => v || '-' },
      { title: 'Estado Nac.', dataIndex: 'estadoNacimiento', key: 'edoNac', width: 110, render: (v) => v || '-' },
    ]

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Importar Empleados"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            this.state.archivoError
              ? <ButtonItem onClick={this.descargarArchivoErrores.bind(this)}>Descargar Errores</ButtonItem>
              : null
          }
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={this.state.loading} tip="Cargando, espere por favor">
            <Alert
              type="info"
              showIcon
              style={{ marginTop: 10 }}
              message="Para traer empleados de otra empresa: en esa empresa entra a Empleados → Exportar Empleados y sube aquí el archivo que descargues. Es esta misma plantilla."
            />
            <Form
              ref={this.formRef}
              name="importarEmpleados"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Importar
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row style={{ marginTop: 20 }}>
                <Col span={12} xs={24} sm={24} lg={12} xl={12} style={{ display: 'flex', justifyContent: 'center' }}>
                  <ButtonItem onClick={() => this.descargarPlantilla()} type="primary">
                    Descargar Plantilla
                  </ButtonItem>
                </Col>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem name="archivo" label="Archivo">
                    <Upload
                      showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                      fileList={this.state.archivosExcel}
                      customRequest={this.onChangeArchivo.bind(this)}
                      accept='.xlsx'
                    >
                      <ButtonItem icon={<UploadOutlined />}>Subir</ButtonItem>
                    </Upload>
                  </FormItem>
                </Col>
              </Row>
            </Form>
            {this.state.avisosCatalogo.length > 0 && (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 15 }}
                message="Valores que no existen en los catálogos de la empresa"
                description={
                  <>
                    <div style={{ marginBottom: 6 }}>
                      Los empleados se importan de todos modos, pero estos campos quedarán vacíos.
                      Da de alta estos valores en su catálogo con el mismo nombre (o corrige el archivo) y vuelve a subirlo para que se llenen.
                    </div>
                    <ul style={{ margin: 0, paddingLeft: 20 }}>
                      {this.state.avisosCatalogo.map((g) => (
                        <li key={g.catalogo}>
                          <b>{g.catalogo}:</b>{' '}
                          {g.valores.map((v) => `${v.valor} (${v.filas} empleado${v.filas !== 1 ? 's' : ''})`).join(', ')}
                        </li>
                      ))}
                    </ul>
                  </>
                }
              />
            )}
            <TableItem
              size="small"
              dataSource={this.state.data}
              columns={columns}
              scroll={{ x: 'max-content' }}
            />
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ImportarEmpleados);
